import "@/lib/localeGuard"; // DEVE restare in cima: applica la lingua preferita prima di App
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Rotte con mappa 3D interattiva (WebGL: Google Earth/Map3DElement).
// Lo snapshot prerenderizzato è ottimo per i CRAWLER (SEO), ma per i BROWSER reali
// l'hydration su queste pagine — che hanno contenuti async (recensioni, CMS, guide)
// e un motore 3D — è fragile: un mismatch lascia il bottone "Esplora"/l'avvio 3D in
// stato inconsistente e la mappa non parte (→ fallback dopo il watchdog).
// Su QUESTE rotte facciamo un render PULITO (createRoot) che sostituisce lo snapshot:
// la mappa parte sempre, come subito dopo un deploy. Le altre pagine restano invariate
// (hydrate) → il prerender NON viene toccato e la SEO resta identica per i crawler.
const MAP_ROUTES = new Set([
  '/parchi', '/parchi-3d', '/parchi-preview', '/parco-3d',
  '/il-parco-della-sila', '/vacanza', '/componi-vacanza', '/intro-test',
]);
const cleanPath = (window.location.pathname || '/')
  .replace(/^\/(en|es)(?=\/|$)/, '') // togli prefisso lingua (/en, /es)
  .replace(/\/+$/, '') || '/'; // togli slash finale
const isInteractiveMapRoute = MAP_ROUTES.has(cleanPath);

// react-snap: se l'HTML e' gia' prerenderizzato (build-time) facciamo HYDRATE,
// altrimenti render normale (client-side). Cosi' i crawler ricevono HTML completo.
if (rootEl.hasChildNodes() && !isInteractiveMapRoute) {
  ReactDOM.createRoot(rootEl).render(app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}
